"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Resource = exports.Link = exports.ResourceGroupBody = exports.ResourceGroup = exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _linkList = babelHelpers.interopRequireDefault(require("./linkList"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _corePlugin = babelHelpers.interopRequireDefault(require("core-plugin"));

var _trackObjectView = babelHelpers.interopRequireDefault(require("trackObjectView"));

var _noty = require("noty");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp, _class3, _descriptor8, _descriptor9, _temp2, _class5, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _temp3, _class7, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _temp4, _class9, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _temp5;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ContentGroupBlock = (_class9 = (_temp5 =
/*#__PURE__*/
function (_LinkListBlock) {
  babelHelpers.inherits(ContentGroupBlock, _LinkListBlock);

  function ContentGroupBlock() {
    var _babelHelpers$getProt5;

    var _this6;

    babelHelpers.classCallCheck(this, ContentGroupBlock);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this6 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt5 = babelHelpers.getPrototypeOf(ContentGroupBlock)).call.apply(_babelHelpers$getProt5, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this6, "showButton", _descriptor21, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "groupLink", _descriptor22, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "promoButtonText", _descriptor23, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "resourceGroups", _descriptor24, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    return _this6;
  }

  babelHelpers.createClass(ContentGroupBlock, [{
    key: "getChildren",
    value: function getChildren() {
      var _this7 = this;

      if (this.displayMode == 'resourceList') {
        return this.resourceGroups.map(function (item) {
          return _react.default.createElement(ResourceGroup, _extends({
            className: _this7.className,
            key: item.id
          }, item));
        });
      }

      return babelHelpers.get(babelHelpers.getPrototypeOf(ContentGroupBlock.prototype), "getChildren", this).call(this);
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      if (this.showButton) {
        var Node,
            attributes = {
          className: 'btn-secondary'
        };

        if (this.displayMode == 'none') {
          Node = 'span';
        } else {
          Node = 'a';
          attributes.href = this.groupLink;
        }

        return _react.default.createElement("div", {
          className: "container"
        }, _react.default.createElement(Node, attributes, this.promoButtonText));
      }

      return null;
    }
  }]);
  return ContentGroupBlock;
}(_linkList.default), _temp5), (_descriptor21 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "showButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "groupLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "promoButtonText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "resourceGroups", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class9);
exports.default = ContentGroupBlock;
var ResourceGroup = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ResourceGroup, _Component);

  function ResourceGroup() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ResourceGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ResourceGroup)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "height", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "blockType", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "blockId", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "groupId", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "content", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "title", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "className", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ResourceGroup, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "".concat(this.className, " height-").concat(this.height),
        "data-block-type": this.blockType,
        "data-block-id": this.blockId,
        "data-group-id": this.groupId
      }, _react.default.createElement(ResourceGroupBody, {
        title: this.title,
        items: this.content
      }));
    }
  }], [{
    key: "checkObjectAccess",
    get: function get() {
      return require("access-control/check-object-access").default;
    }
  }]);
  return ResourceGroup;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "height", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "blockType", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "blockId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "groupId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "className", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class, "checkObjectAccess", [_decorators.memoize], Object.getOwnPropertyDescriptor(_class, "checkObjectAccess"), _class)), _class);
exports.ResourceGroup = ResourceGroup;
var ResourceGroupBody = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(ResourceGroupBody, _Component2);

  function ResourceGroupBody() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, ResourceGroupBody);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(ResourceGroupBody)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "title", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "items", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(ResourceGroupBody, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "resource-group"
      }, _react.default.createElement("h1", null, this.title), _react.default.createElement("div", {
        className: "resource-group-items"
      }, this.items.map(function (item) {
        return _react.default.createElement(_react.Fragment, {
          key: item.id
        }, _react.default.createElement(Resource, item));
      })));
    }
  }]);
  return ResourceGroupBody;
}(_react.Component), _temp2), (_descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "items", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.ResourceGroupBody = ResourceGroupBody;
var Link = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(Link, _Component3);

  function Link() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, Link);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(Link)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "link", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "openInNewWindow", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "title", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "host", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(Link, [{
    key: "render",
    value: function render() {
      var attrs = {};
      if (this.openInNewWindow) attrs.target = '_blank';
      return _react.default.createElement("a", {
        className: "link",
        href: this.link,
        target: attrs.target
      }, _react.default.createElement("div", {
        className: "link-content"
      }, _react.default.createElement("div", {
        className: "link-title"
      }, this.title), _react.default.createElement("div", {
        className: "link-host"
      }, this.host)));
    }
  }]);
  return Link;
}(_react.Component), _temp3), (_descriptor10 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "link", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "openInNewWindow", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "host", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
exports.Link = Link;
var Resource = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(Resource, _Component4);

  function Resource() {
    var _babelHelpers$getProt4;

    var _this4;

    babelHelpers.classCallCheck(this, Resource);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(Resource)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "link", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "access", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "pdfOptions", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "title", _descriptor17, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "fileName", _descriptor18, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "tool", _descriptor19, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "id", _descriptor20, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    return _this4;
  }

  babelHelpers.createClass(Resource, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("a", {
        className: "resource-document",
        href: this.link,
        onClick: this.showDocument
      }, _react.default.createElement("div", {
        className: "document-icon"
      }, _react.default.createElement("div", {
        className: "document-type"
      }, this.fileName.split('.').pop())), _react.default.createElement("div", {
        className: "document-name"
      }, this.title));
    }
  }, {
    key: "showDocument",
    value: function showDocument(event) {
      var _this5 = this;

      if (this.access == 'enabled') {
        event.preventDefault();
        var D = this.pdfOptions;
        var tgt;
        if (!D || !D.pdf) tgt = window.open('about:blank', '_blank');
        (0, _fetch.default)("access/".concat(this.tool, "/").concat(this.id)).then(function (result) {
          return result.json();
        }).then(function (data) {
          if (data.access == 'enabled') {
            (0, _trackObjectView.default)('catalog', _this5.id, true);

            if (tgt) {
              tgt.location.href = data.detail.signedDocumentURL;
            } else {
              var opt = {};
              opt.toolbar = !!D.toolbar;
              opt.controls = D.toolbar ? Object.keys(D.toolbar).filter(function (v) {
                return D.toolbar[v];
              }).join(',') : '';
              if (data.detail.password) opt.password = data.detail.password;
              opt.file = data.detail.signedDocumentURL;
              var optString = Object.keys(opt).map(function (key) {
                return [key, opt[key]].map(encodeURIComponent).join('=');
              }).join('&');
              var f = document.createElement('div');
              f.id = 'document-viewer-modal-wrap';
              f.className = 'modal-wrapper fade';
              f.innerHTML = "\n\t\t\t\t\t\t\t<div class='modal modal-full modal-full-align-top fade' id='document-viewer-modal' role='dialog' tabindex='-1' aria-hidden='true'\n\t\t\t\t\t\t\t\tdata-backdrop-parent='#document-viewer-modal-wrap'\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<div class='modal-dialog'>\n\t\t\t\t\t\t\t\t\t<div class='modal-content'>\n\t\t\t\t\t\t\t\t\t\t<div class='modal-header'>\n\t\t\t\t\t\t\t\t\t\t\t".concat(BLX.modalCloseButton(), "\n\t\t\t\t\t\t\t\t\t\t\t<h4 class='modal-title'>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class='material-icons' data-icon='insert_drive_file'></span>\n\t\t\t\t\t\t\t\t\t\t\t\tDocument\n\t\t\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class='modal-body'>\n\t\t\t\t\t\t\t\t\t\t\t<iframe id='document-viewer'></iframe>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t");
              f.querySelector('iframe').src = "/admin/platform/plugins/".concat(_corePlugin.default, "/libraries/pdf.js/web/viewer.html?").concat(optString);
              document.body.appendChild(f);
              $(f.querySelector('.modal')).on('hidden.bs.modal', function () {
                return $(f).remove();
              }).modal('show');
            }
          } else {
            if (tgt) tgt.close();
            (0, _noty.showNotificationText)("You do not have permission to view that resource.", 'danger', 'warning');
          }
        });
      }
    }
  }]);
  return Resource;
}(_react.Component), _temp4), (_descriptor14 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "link", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "access", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "pdfOptions", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "fileName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "tool", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "showDocument", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "showDocument"), _class7.prototype)), _class7);
exports.Resource = Resource;